export interface IGetLabelValueComboboxByFormRequest {
    token?: string;
    _atividadeNo: number;
}

export interface IGetLabelValueComboboxByFormResponse {
    DefaultValue: string;
    Rotulo: string;
    Valor: any;
}